import React from 'react';
import './HealthNutritionCard.scss';
import { parseUptoDecimal } from '../../services';
import { formatNumberWithCommas } from '../../utill.func';

const HealthNutritionCard = ({ nutritionData, maxValueToShow }) => {
  return (
    <div key={'nutrition'} className="nutrition-card-container">
      <div className="card">
        <div className="nutrition-card-heading">
          <span className="heading-font padding-small">กินแล้ว</span>
          <span className="heading-font padding-large">เป้าหมาย</span>
          <span className="heading-font">เหลืออีก</span>
        </div>
        {nutritionData.map((item, index) => {
          const value = parseUptoDecimal(item?.value);
          const max = parseUptoDecimal(item?.max);
          const diff = parseUptoDecimal(item?.diff);
          return (
            <div key={item?.label}>
              <div key={`bar${index}`} className="bar-nutrition">
                <div className="heading-font">{item?.label}</div>
                <div className="bar-nutrition-values">
                  <span className="values-font ">
                    {value
                      ? value > maxValueToShow
                        ? `${formatNumberWithCommas(maxValueToShow)}+`
                        : formatNumberWithCommas(value)
                      : '-'}
                  </span>
                  <span className="values-font ">
                    {max ? formatNumberWithCommas(max) : '-'}
                  </span>
                  <span className="values-font">
                    {diff ? formatNumberWithCommas(diff) : '-'}
                  </span>
                </div>
              </div>
              <progress
                key={`progress${index}`}
                value={value ?? '-'}
                max={max ?? '-'}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HealthNutritionCard;
